export default __webpack_public_path__ + "static/media/blockchain-service.82ada1f1.jpeg";